import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=4c68a6d9&scoped=true"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"
import style0 from "./ChatPage.vue?vue&type=style&index=0&id=4c68a6d9&prod&scoped=true&lang=scss"
import style1 from "./ChatPage.vue?vue&type=style&index=1&id=4c68a6d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68a6d9",
  null
  
)

export default component.exports